import CountriesComponent from '../../components/Countries/Countries';

function Countries() {
  return <CountriesComponent />;
}

export default Countries;
